import { useMsal } from "@azure/msal-react";
import { loginRequest } from "auth/authConfig";
import { useStore } from "react-redux";
import { setAccessToken } from "store/session";
import store from "store/store";
import config from "../config";
import {
    sanitizeInput,
    normalizeValue
} from "./ValueNormalizer";
import {sanitizeNumericMultiValue} from "./Common"

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export async function GetToken(instance) {
    const state = store.getState();

    await instance.acquireTokenSilent({ ...loginRequest, account: state.sessionState.user }).then((response) => {
        store.dispatch(setAccessToken(response.accessToken));
        return response.accessToken;
    }).catch((e) => {
        instance.acquireTokenPopup({ ...loginRequest, account: state.sessionState.user }).then((response) => {
            store.dispatch(setAccessToken(response.accessToken));
            return response.accessToken;
        });
    });
}


export async function PDMLogin(instance) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("Authorization", bearer);
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    let output = null;

    await fetch(config.restUrl + "PDM/Login", {
        method: "GET",
        headers: headers
    }).then(res => res.json()).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function fetchId(instance, ad_name) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("Authorization", bearer);
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("ad_name", ad_name);

    let output = null;

    await fetch(config.restUrl + "PDM/FetchId", {
        method: "GET",
        headers: headers
    }).then(res => res.json()).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function fetchValidationId(instance) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    let output = null;

    await fetch(config.restUrl + "Validation/FetchRollId", {
        method: "GET",
        headers: headers
    }).then(res => res.json()).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function fetchCompareId(instance) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    let output = null;

    await fetch(config.restUrl + "Compare/FetchRollId", {
        method: "GET",
        headers: headers
    }).then(res => res.json()).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function fetchMaterialCharacteristics(instance, ad_name, material, revision) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("Authorization", bearer);
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("ad_name", ad_name);

    let output = null;
    await fetch(config.restUrl + "PDM/FetchMaterialCharacteristics/" + material + "/" + revision, {
        method: "GET",
        headers: headers
    }).then(res => res.json()).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function downloadTrace(instance, order_name, ad_name) {
    await GetToken(instance);
    const state = store.getState();
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("ad_name", ad_name);

    let output = null;
    let fetchUrl = config.restUrl + "PDM/GetConfigTrace?ordername=" + order_name;

    await fetch(fetchUrl,
        {
            method: "POST",
            headers: headers
        }
    ).then(res => res.json()).then((result) => {

        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";

        const blob = new Blob([result], { type: "text/plain" });
        const href = window.URL.createObjectURL(blob);
        a.href = href;
        a.download = "trace.txt";
        a.click();
        window.URL.revokeObjectURL(href);

        console.log("Download completed.");
        sessionStorage.setItem("successDownloadXML", "true");
    }).catch(error => {
        console.log(error);
        sessionStorage.setItem("failedDownloadXML", "true");
    });
    sessionStorage.setItem("circularProgressXML", "false");
    let successDownloadXML = sessionStorage.getItem("successDownloadXML");
    sessionStorage.removeItem("successDownloadXML");

    let failedDownloadXML = sessionStorage.getItem("failedDownloadXML");
    sessionStorage.removeItem("failedDownloadXML");

    var msg = "";
    if (successDownloadXML != null && successDownloadXML == "true") {
        msg = "File downloaded successfully";
    }
    else if (failedDownloadXML == null) {
        msg = "File downloading failed";
    }
    else {
        msg = "File downloading failed (Gateway Timeout)";
    }
    setTimeout(() => {
        alert(msg);
    }, 1500);
    return output;
}

export async function CheckConfigTraceExists(instance, order_name, ad_name) {
    await GetToken(instance);

    const state = store.getState();
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");

    let headers = new Headers();
    headers.append("Authorization", "Bearer " + state.sessionState.token);
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("ad_name", ad_name);

    let fetchUrl =
        config.restUrl +
        "PDM/CheckConfigTraceExists?ordername=" +
        order_name;

    try {
        const response = await fetch(fetchUrl, {
            method: "POST",
            headers: headers
        });

        if (!response.ok) {
            return false;
        }

        return await response.json();
    }
    catch (error) {
        console.log("CheckConfigTraceExists failed", error);
        return false;
    }
}

export async function materialRevisionItemsExists(instance, materialRevisionCondition, ad_name) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("Authorization", bearer);
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("ad_name", ad_name);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');

    let output = null;
    await fetch(config.restUrl + "PDM/MaterialRevisionItemsExist", {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            // parameters
            "materialsRevisionsCondition": materialRevisionCondition,
        })
    }).then(res => res.json()).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function getConsoleMaterials(instance, _userName) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);

    let output = null;
    await fetch(config.restUrl + "CWSConsole/GetMaterials/" + _userName, {
        method: 'GET',
        headers: headers
    }
    ).then(res => res.json()).then((result) => {
        output = result;
    });
    return output;
}

export async function getBatches(instance) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    let output = null;
    await fetch(config.restUrl + "Batch",
        {
            method: "GET",
            headers: headers
        }
    ).then(res => {
        console.log("RES: ", res);
        return res.json();
    }
    ).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function getBatchesFiltered(instance, namefilter) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    let output = null;
    await fetch(config.restUrl + "getBatches/" + namefilter,
        {
            method: "GET",
            headers: headers
        }
    ).then(res => {
        console.log("RES: ", res);
        return res.json();
    }
    ).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function getBatch(instance, _batchId) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    let output = null;
    await fetch(config.restUrl + "Batch/" + _batchId,
        {
            method: "GET",
            headers: headers
        }
    ).then(res => {
        return res.json();
    }
    ).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export const normalizeListItem = (value) => {
    const items = [];
  
    const addItem = (valueToAdd) => {
      if (valueToAdd === null || valueToAdd === undefined) {
        return;
      }
  
      let item = String(valueToAdd).trim();
  
      if (!item) {
        return;
      }
  
      // Remove surrounding quotes.
      item = item
        .replace(/^["']+/, "")
        .replace(/["']+$/, "")
        .trim();
  
      // Remove remaining brackets/quotes/backslashes.
      item = item
        .replace(/^\[+/, "")
        .replace(/\]+$/, "")
        .replace(/^["']+/, "")
        .replace(/["']+$/, "")
        .trim();
  
      if (!item || item === "[]") {
        return;
      }
  
      if (!items.includes(item)) {
        items.push(item);
      }
    };
  
    const decode = (current, depth = 0) => {
      if (
        depth > 50 ||
        current === null ||
        current === undefined
      ) {
        return;
      }
  
      // Array -> recursively process every element.
      if (Array.isArray(current)) {
        current.forEach((item) => {
          decode(item, depth + 1);
        });
        return;
      }
  
      // Object -> recursively process values.
      if (typeof current === "object") {
        Object.values(current).forEach((item) => {
          decode(item, depth + 1);
        });
        return;
      }
  
      let text = String(current).trim();
  
      if (!text) {
        return;
      }
  
      /*
       * Keep decoding JSON layers.
       *
       * IMPORTANT:
       * Do NOT remove backslashes before JSON.parse().
       */
      for (let i = 0; i < 50; i += 1) {
        text = text.trim();
  
        if (!text) {
          return;
        }
  
        const first = text.charAt(0);
        const last = text.charAt(text.length - 1);
  
        const looksLikeJson =
          (first === "[" && last === "]") ||
          (first === "{" && last === "}") ||
          (first === '"' && last === '"');
  
        if (!looksLikeJson) {
          break;
        }
  
        try {
          const parsed = JSON.parse(text);
  
          // JSON array.
          if (Array.isArray(parsed)) {
            decode(parsed, depth + 1);
            return;
          }
  
          // JSON object.
          if (
            parsed !== null &&
            typeof parsed === "object"
          ) {
            decode(parsed, depth + 1);
            return;
          }
  
          // Another encoded string.
          if (typeof parsed === "string") {
            if (parsed === text) {
              break;
            }
  
            text = parsed;
            continue;
          }
  
          break;
        } catch (error) {
          // Not JSON anymore. Process as plain text.
          break;
        }
      }
  
      /*
       * At this point, text should contain the actual value,
       * e.g. "T89/B" or "RG100".
       */
  
      text = text
        .replace(/\r\n/g, "")
        .replace(/\r/g, "")
        .replace(/\n/g, "")
        .trim();
  
      // Remove brackets and quotes left by malformed/partial encoding.
      text = text
        .replace(/\[|\]/g, "")
        .replace(/^["']+|["']+$/g, "")
        .replace(/\\"/g, '"')
        .replace(/\\+/g, "")
        .trim();

  
      if (!text) {
        return;
      }
  
      /*
       * Comma is the ONLY separator.
       */
      text.split(",").forEach((item) => {
        addItem(item);
      });
    };
  
    decode(value);
  
    return items.join(",");
};


export const normalizeCharacteristicListValue = (value) => {
return String(normalizeListItem(value) || "").trim();
};
  
  
  

export async function GetBatchParameters(instance, _batchid) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    let output = null;                     
    console.log(_batchid);                         
    await fetch(config.restUrl + "Batch/" + _batchid + "/parameters", {
        method: 'GET',
        headers: headers
    }
    ).then(res => res.json()).then((result) => {
        output = result;

        const characteristicDataTypes = {};
        const defaultCharacteristics = result.defaultCharacteristics;

        const predefaultCharacteristics = defaultCharacteristics || [];

        predefaultCharacteristics.forEach((characteristic) => {
            if (characteristic && characteristic.name) {
                characteristicDataTypes[characteristic.name] = {
                    dataType: characteristic.dataType,
                    cardinality: String(characteristic.cardinality || "").trim().toLowerCase(),
                };
            }
        });
        
        const orders = result.orders;
        
        if (Array.isArray(orders)) {
            orders.forEach((order) => {
                if (
                    order &&
                    typeof order === "object" &&
                    order.characteristics &&
                    typeof order.characteristics === "object"
                ) {
                    Object.keys(order.characteristics).forEach((key) => {
                        const meta = characteristicDataTypes[key];
                        const dataType = meta ? meta.dataType : undefined;

                       if (
                            meta &&
                            (meta.cardinality === "set" || meta.cardinality === "sequence") &&
                            (String(dataType || "").toLowerCase() === "integer" ||
                                String(dataType || "").toLowerCase() === "float")
                        ) {
                            order.characteristics[key] = sanitizeNumericMultiValue(
                                order.characteristics[key]
                            );
                        } else {
                            order.characteristics[key] =
                                normalizeValue(
                                    order.characteristics[key],
                                    dataType
                                );
                        }
                    });
                }
            });
        }
        output.orders = orders;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function getMaterial(instance, id) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    let output = null;
    await fetch(config.restUrl + "Material/" + id,
        {
            method: "GET",
            headers: headers

            //"Access-Control-Allow-Origin": "*",
            //"Content-Type": "text/plain"

        }
    ).then(res => {
        //console.log("RES: ", res);
        return res.json();
    }
    ).then((result) => {
        output = result;
    });
    return output;
}

export async function getBatchOrders(instance, id) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    let output = null;
    await fetch(config.restUrl + "Batch/" + id + "/Orders",
        {
            method: "GET",
            headers: headers
        }
    ).then(res => res.json()).then((result) => {
        output = result;
    });
    return output;
}

export async function getBatchesErrorModeLists(instance) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);

    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    let output = null;
    await fetch(config.restUrl + "Batch/ErrorModeLists",
        {
            method: "GET",
            headers: headers
        }
    ).then(res => res.json()).then((result) => {
        output = result;
    });
    return output;
}

export async function createBatch(instance, _name, _description, _material, _materialRevision, _orders, _defaultCharacteristics, _executeArguments, _executeOrders, _pdmdescription, _batchSize) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    let output = null;
    console.log(_name);
    console.log(_description);
    console.log(_material);
    console.log(_materialRevision);
    console.log(_orders);
    console.log(_defaultCharacteristics);
    console.log(_pdmdescription);
    await fetch(config.restUrl + "Batch/Create", {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            // parameters
            "name": _name,
            "description": _description,
            "material": _material,
            "materialRevision": _materialRevision,
            "orders": _orders,
            "defaultCharacteristics": _defaultCharacteristics,
            "executeOrders": _executeOrders,
            "executeArguments": _executeArguments,
            "pdmdescription": _pdmdescription,
            "batchSize": _batchSize,
        })
    }
    ).then(res => res.json()).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function createBatchParameters(instance, _batchid, _orders, _defaultCharacteristics) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    let output = null;                     
    console.log(_batchid);                         
    console.log(_orders);         
    console.log(_defaultCharacteristics);
    await fetch(config.restUrl + "Batch/" + _batchid + "/parameters", {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            // parameters
            "orders": _orders,
            "defaultCharacteristics": _defaultCharacteristics
        })
    }
    ).then(res => res.json()).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function updateBatch(instance, _id, _name, _description, _orders, _defaultCharacteristics, _executeArguments, _executeOrders, _pdmdescription, _batchSize) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    let output = null;

    await fetch(config.restUrl + "Batch/" + _id + "/Update", {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            // parameters
            "name": _name,
            "description": _description,
            "orders": _orders,
            "defaultCharacteristics": _defaultCharacteristics,
            "executeOrders": _executeOrders,
            "executeArguments": _executeArguments,
            "pdmdescription": _pdmdescription,
            "batchSize": _batchSize,
        })
    }
    ).then(res => res.json()).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function executeBatch(instance, _batchID, _orders, _executeArguments, batchOrders, ad_name) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("Authorization", bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("ad_name", ad_name);

    let output = null;
    await fetch(config.restUrl + "Batch/" + _batchID + "/Execute", {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            // parameters
            "orderArray": _orders,
            "executeArguments": _executeArguments,
            "orders": batchOrders
        })
    }
    ).then(res => res.json()).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function deleteBatch(instance, _batchId, ad_name) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append("ad_name", ad_name);

    let output = null;
    await fetch(config.restUrl + "Batch/" + _batchId,
        {
            method: "DELETE",
            headers: headers
        }
    ).then(res => {
        return res.json();
    }
    ).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function deleteBatchParameters(instance, _batchid) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    let output = null;                     
    console.log(_batchid);                         
    await fetch(config.restUrl + "Batch/" + _batchid + "/parameters", {
        method: 'DELETE',
        headers: headers
    }
    ).then(res => res.json()).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function RefreshStatus(instance, _batchID, ad_name) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("Authorization", bearer);
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("ad_name", ad_name);

    let output = null;
    await fetch(config.restUrl + "Batch/" + _batchID + "/RefreshAndFetchLatestStatus", {
        method: 'GET',
        headers: headers
    }
    ).then(res => res.json()).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function RefreshBatchStatus(instance, _batchIDs, ad_name) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("Authorization", bearer);
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("ad_name", ad_name);
    headers.append('Content-Type', 'application/json');


    let output = null;
    await fetch(config.restUrl + "Batch/RefreshBatchStatus", {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            // parameters
            "Orders": _batchIDs
        })
    }
    ).then(res => res.json()).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function CancelBatch(instance, _batchID, _orders) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    let output = null;
    await fetch(config.restUrl + "Batch/" + _batchID + "/Cancel", {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            // parameters
            "orders": _orders
        })
    }
    ).then(res => res).then((result) => {
        //console.log("RESULT: ", result);
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}
export async function CancelBatchConsole(instance, _ad_name, _batch_name, _last_run) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("Authorization", bearer);
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("ad_name", _ad_name);
    headers.append("batch_name", _batch_name);
    headers.append("last_run", _last_run);

    console.log(_ad_name);
    console.log(_batch_name);
    console.log(_last_run);
    let output = null;
    await fetch(config.restUrl + "CWSConsole/CancelBatch", {
        method: 'GET',
        headers: headers
    }
    ).then(res => res).then((result) => {
        //console.log("RESULT: ", result);
        output = result;
    }).catch(error => {
        console.log(error);
    });
    console.log(output);
    return output;
}

export async function shareBatch(instance, _batchID, _shareTo) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);


    let output = null;
    await fetch(config.restUrl + "Batch/" + _batchID + "/Share", {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            // parameters
            "shareTo": _shareTo
        })
    }
    ).then(res => res).then((result) => {
        //console.log("RESULT: ", result);
        output = result;
        return output;
    });
}

export async function unShareBatch(instance, _batchID) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);


    let output = null;
    await fetch(config.restUrl + "Batch/" + _batchID + "/Unshare", {
        method: "GET",
        headers: headers
    }
    ).then(res => res).then((result) => {
        output = result;
    });
    return output;
}

// export async function unShareBatch(instance, _batchID, _removeFrom) {
//     await GetToken(instance);
//     const state = store.getState();
//     let headers = new Headers();
//     let bearer = "Bearer " + state.sessionState.token;
//     headers.append("Authorization", bearer);
//     headers.append('Accept', 'application/json');
//     headers.append('Content-Type', 'application/json');
//     let output = null;
//     await fetch(config.restUrl + "Batch/" + _batchID + "/Unshare", {
//         method: 'POST',
//         headers: headers,
//         body: JSON.stringify({
//             // parameters
//             "sharedBy": config.userName,
//             "removeFrom": _removeFrom
//         })
//     }
//     ).then(res => res).then((result) => {
//         output = result;
//     });
//     return output;
// }

export async function createOrder(instance, _batchID, _name, _description, _characteristics, _userName) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);


    let output = null;
    await fetch(config.restUrl + "Order/Create", {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            // parameters
            "batchID": _batchID,
            "name": _name,
            "description": _description,
            "characteristics": _characteristics,
            "userName": _userName
        })
    }
    ).then(res => res.json()).then((result) => {
        output = result;
    });
    return output;
}

export async function updateOrder(instance, _orderID, _batchID, _name, _description, _status, _message, _characteristics) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);


    let output = null;
    await fetch(config.restUrl + "Order/" + _orderID, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            // parameters
            "batchID": _batchID,
            "name": _name,
            "description": _description,
            "characteristics": _characteristics,
            "status": _status,
            "message": _message
        })
    }
    ).then(res => res.json()).then((result) => {
        output = result;
    });
    return output;
}

export async function getSharedWith(instance, _userName = store.getState().sessionState.user.username) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);


    let output = null;
    await fetch(config.restUrl + "Share/SharedWith/" + _userName,
        {
            method: "GET",
            headers: headers
        }
    ).then(res => res.json()).then((result) => {
        output = result;
    });
    return output;
}

export async function getSharedBy(instance, _userName = store.getState().sessionState.user.username) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);

    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    let output = null;
    await fetch(config.restUrl + "Share/SharedBy/" + _userName,
        {
            method: "GET",
            headers: headers
        }
    ).then(res => res.json()).then((result) => {
        output = result;
    });
    return output;
}

export async function getSharedWithMe(instance) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);

    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    let output = null;
    await fetch(config.restUrl + "Batch/SharedWithMe",
        {
            method: "GET",
            headers: headers
        }
    ).then(res => res.json()).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function getValidations(instance) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);


    let output = null;
    let fetchUrl = config.restUrl + "Validation";

    await fetch(fetchUrl,
        {
            method: "GET",
            headers: headers
        }
    ).then(res => res.json()).then((result) => {
        output = result;
    });
    return output;
}

export async function getValidation(instance, _validationid) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);


    let output = null;
    await fetch(config.restUrl + "Validation/" + _validationid,
        {
            method: "GET",
            headers: headers
        }
    ).then(res => {
        return res.json();
    }
    ).then((result) => {
        output = result;
    });
    return output;
}

export async function createValidation(instance, _validationType, _name, _description, _materials, _options, _pdmdescription, _dvalert_status) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');

    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    let output = null;
    await fetch(config.restUrl + "Validation/Create", {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            // parameters
            "validationType": _validationType,
            "name": _name,
            "description": _description,
            "materials": _materials,
            "options": _options,
            "pdmdescription": _pdmdescription,
            "dvalertstatus": _dvalert_status,
        })
    }
    ).then(res => res.json()).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function updateValidation(instance, _validationid, _name, _description, _materials, _options, _pdmdescription, _dvalert_status) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');

    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    let output = null;
    await fetch(config.restUrl + "Validation/" + _validationid + "/Update", {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            // parameters
            "name": _name,
            "description": _description,
            "materials": _materials,
            "options": _options,
            "pdmdescription": _pdmdescription,
            "dvalertstatus": _dvalert_status,
        })
    }
    ).then(res => res.json()).then((result) => {
        output = result;
    });
    return output;
}

export async function executeValidation(instance, _validationid, _materials, _options, ad_name) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("Authorization", bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("ad_name", ad_name);


    let output = null;
    await fetch(config.restUrl + "Validation/" + _validationid + "/Execute", {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            // parameters
            "materials": _materials,
            "options": _options
        })
    }
    ).then(res => res.json()).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function deleteValidation(instance, _validationId, ad_name) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append("ad_name", ad_name);


    let output = null;
    await fetch(config.restUrl + "Validation/" + _validationId,
        {
            method: "DELETE",
            headers: headers
        }
    ).then(res => {
        return res.json();
    }
    ).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function downloadFromS3Base64(instance, _route, _name, ad_name) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append("ad_name", ad_name);

    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    let output = null;
    let fetchUrl = config.restUrl + _route + "/DownloadFromS3Base64/" + _name;
    console.log(fetchUrl);
    await fetch(fetchUrl,
        {
            method: "GET",
            headers: headers
        }
    ).then(res => res.json()).then((result) => {
        const byteCharacters = atob(result);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        const href = window.URL.createObjectURL(blob);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = href;
        a.download = _name + ".xlsx";
        a.click();
        window.URL.revokeObjectURL(href);
        console.log("Download completed.");

    }).catch(error => {
        console.log(error);
    });

    return output;
}

/*export async function getCompares(instance, _userid, _compareType = "") {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    let output = null;
    let fetchUrl = config.restUrl + "Compare/" + _userid;
    if (_compareType != "")
    {
        fetchUrl = fetchUrl + "?compareType=" + _compareType
    }
    await fetch(fetchUrl, 
    {
        method: "GET",
        headers: headers
    }
    ).then(res => res.json()).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}*/

export async function getCompares(instance) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);

    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    let output = null;
    let fetchUrl = config.restUrl + "Compare";

    await fetch(fetchUrl,
        {
            method: "GET",
            headers: headers
        }
    ).then(res => res.json()).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function getCompare(instance, _compareID) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);

    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    let output = null;
    await fetch(config.restUrl + "Compare/" + _compareID,
        {
            method: "GET",
            headers: headers
        }
    ).then(res => {
        return res.json();
    }
    ).then((result) => {
        output = result;
    });
    return output;
}

export async function getPdmCadCompareV2Status(instance, configurationId) {
    await GetToken(instance);

    const state = store.getState();

    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;

    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");

    headers.append("Authorization", bearer);
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("ad_name", state.sessionState.user?.username || "");
    headers.append("Content-Type", "application/json");

    let output = null;

    await fetch(config.restUrl + "PdmCadCompareV2/Status", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            configurationId: configurationId,
            environment: config.environment
        })
    })
    .then(res => res.json())
    .then((result) => {
        output = result;
    })
    .catch(error => {
        console.log(error);
        output = {
            exists: false,
            started: false,
            modelCheckExists: false,
            status: "Failed",
            message: "PDM CAD Comparison V2 status check failed."
        };
    });

    return output;
}

export async function resolvePdmCadCompareV2(instance, configurationId) {
    await GetToken(instance);

    const state = store.getState();

    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;

    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");

    headers.append("Authorization", bearer);
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("ad_name", state.sessionState.user?.username || "");
    headers.append("Content-Type", "application/json");

    let output = null;

    await fetch(config.restUrl + "PdmCadCompareV2/Resolve", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            configurationId: configurationId,
            environment: config.environment
        })
    })
    .then(res => res.json())
    .then((result) => {
        output = result;
    })
    .catch(error => {
        console.log(error);
        output = {
            exists: false,
            started: false,
            status: "Failed",
            message: "PDM CAD Comparison request failed."
        };
    });

    return output;
}

export async function createCompare(instance, _compareType, _name, _description, _configurations, _compareto, _options) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);


    let output = null;
    await fetch(config.restUrl + "Compare/Create", {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            // parameters
            "compareType": _compareType,
            "name": _name,
            "description": _description,
            "configurations": _configurations,
            "compareto": _compareto,
            "options": _options
        })
    }
    ).then(res => res.json()).then((result) => {
        output = result;
    });
    return output;
}

export async function updateCompare(instance, _compareid, _name, _description, _configurations, _compareto, _options) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');

    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    let output = null;
    await fetch(config.restUrl + "Compare/" + _compareid + "/Update", {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            // parameters
            "name": _name,
            "description": _description,
            "configurations": _configurations,
            "compareto": _compareto,
            "options": _options
        })
    }
    ).then(res => res.json()).then((result) => {
        output = result;
    });
    return output;
}

export async function executeCompare(instance, _compareid, _configurations, _compareto, _options, ad_name) {
    await GetToken(instance);
    const state = store.getState();
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("ad_name", ad_name);


    let output = null;
    await fetch(config.restUrl + "Compare/" + _compareid + "/Execute", {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            // parameters
            "configurations": _configurations,
            "compareto": _compareto,
            "options": _options
        })
    }
    ).then(res => res.json()).then((result) => {
        output = result;
    });
    return output;
}

export async function deleteCompare(instance, _compareId, ad_name) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append("ad_name", ad_name);


    let output = null;
    await fetch(config.restUrl + "Compare/" + _compareId,
        {
            method: "DELETE",
            headers: headers
        }
    ).then(res => {
        return res.json();
    }
    ).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function OptionsPackageDownload(instance, _koneMaterial, _koneMaterialRevision, ad_name) {
    await GetToken(instance);
    const state = store.getState();
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("ad_name", ad_name);


    let output = null;
    let fetchUrl = config.restUrl + "CWSConsole/DownloadOptionsPackage?&material=" + _koneMaterial + "&revision=" + _koneMaterialRevision;

    await fetch(fetchUrl,
        {
            method: "GET",
            headers: headers
        }
    ).then(res => res.json()).then((result) => {

        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";

        const byteCharacters = atob(result);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: "application/octet-stream" });
        const href = window.URL.createObjectURL(blob);
        a.href = href;
        a.download = _koneMaterial + "_" + _koneMaterialRevision + ".zip";
        a.click();
        window.URL.revokeObjectURL(href);
        console.log("Download completed.");

    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function OptionsPackageUpload(instance, _koneMaterial, _koneMaterialRevision, _zipFile, _fileBinaryStr, ad_name) {
    await GetToken(instance);
    const state = store.getState();
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    let headers = new Headers();
    let fData = new FormData();
    fData.append("file", _fileBinaryStr);
    fData.append("UploaderName", ad_name);
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("ad_name", ad_name);


    let output = null;
    let fetchUrl = config.restUrl + "CWSConsole/UploadOptionsPackage?&material=" + _koneMaterial + "&revision=" + _koneMaterialRevision + "&zipName=" + _zipFile;

    const response = await fetch(fetchUrl, {
        method: "POST",
        headers: headers,
        body: fData
    });

    const result = await response.json();

    if (!response.ok) {
        const validationErrors = result?.errors
            ? Object.keys(result.errors)
                .map(key => {
                    const messages = result.errors[key];
                    return Array.isArray(messages)
                        ? messages.join("\n")
                        : String(messages);
                })
                .join("\n")
            : "";

        throw new Error(
            validationErrors ||
            result?.detail ||
            result?.title ||
            `CAD options file upload failed (${response.status}).`
        );
    }

    if (result !== "success") {
        throw new Error(
            typeof result === "string" && result
                ? result
                : "CAD options file upload failed."
        );
    }

    return result;
}

export async function CheckResultExists(instance, configuration_id, result_type, ad_name) {
    console.log("CheckResultExists started", configuration_id, result_type);

    try {
        await GetToken(instance);

        const state = store.getState();

        let pdmUsername = sessionStorage.getItem("pdmUsername");
        let pdmPassword = sessionStorage.getItem("pdmPassword");

        let headers = new Headers();

        headers.append("Authorization", "Bearer " + state.sessionState.token);
        headers.append("username", pdmUsername);
        headers.append("password", pdmPassword);
        headers.append("ad_name", ad_name);
        headers.append("configuration_id", configuration_id);
        headers.append("result_type", result_type);

        let fetchUrl = config.restUrl + "CWSConsole/CheckResultExists";

        console.log("Calling CheckResultExists API", fetchUrl);

        const response = await fetch(fetchUrl, {
            method: "GET",
            headers: headers
        });

        console.log("CheckResultExists response status", response.status);

        if (!response.ok) {
            console.log("CheckResultExists request failed");
            return false;
        }

        const result = await response.json();

        console.log("CheckResultExists result", configuration_id, result_type, result);

        return result === true;
    }
    catch (error) {
        console.log("CheckResultExists exception", configuration_id, result_type, error);
        return false;
    }
}

export async function DownloadConsoleResults(instance, order_name, configuration_id, result_type, ad_name) {
    await GetToken(instance);
    const state = store.getState();
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("ad_name", ad_name);
    headers.append("configuration_id", configuration_id);
    headers.append("result_type", result_type);


    let output = null;
    let fetchUrl = config.restUrl + "CWSConsole/DownloadResults";

    await fetch(fetchUrl,
        {
            method: "GET",
            headers: headers
        }
    ).then(res => res.json()).then((result) => {

        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";

        const byteCharacters = atob(result);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers)
        if (result_type == "XML") {
            const blob = new Blob([byteArray], { type: "text/xml" });
            const href = window.URL.createObjectURL(blob);
            a.href = href;
            a.download = configuration_id.replace('/', '_') + ".xml";
            a.click();
            window.URL.revokeObjectURL(href);
        }
        else {
            const blob = new Blob([byteArray], { type: "application/octet-stream" });
            const href = window.URL.createObjectURL(blob);
            a.href = href;
            a.download = order_name + "_" + result_type + ".zip";
            a.click();
            window.URL.revokeObjectURL(href);
        }
        console.log("Download completed.");
        sessionStorage.setItem("successDownloadXML", "true");
    }).catch(error => {
        console.log(error);
        sessionStorage.setItem("failedDownloadXML", "true");
    });
    sessionStorage.setItem("circularProgressXML", "false");
    let successDownloadXML = sessionStorage.getItem("successDownloadXML");
    sessionStorage.removeItem("successDownloadXML");

    let failedDownloadXML = sessionStorage.getItem("failedDownloadXML");
    sessionStorage.removeItem("failedDownloadXML");

    var msg = "";
    if (successDownloadXML != null && successDownloadXML == "true") {
        msg = result_type + " file downloaded successfully";
    }
    else if (failedDownloadXML == null) {
        msg = result_type + " file downloading failed";
    }
    else {
        msg = result_type + " file downloading failed (Gateway Timeout)";
    }
    setTimeout(() => {
        alert(msg);
    }, 1500);
    return output;
}

export async function PrepareConfigurationXml(instance, configuration_id, ad_name) {
    await GetToken(instance);

    const state = store.getState();
    const pdmUsername = sessionStorage.getItem("pdmUsername");
    const pdmPassword = sessionStorage.getItem("pdmPassword");

    const headers = new Headers();
    headers.append("Authorization", "Bearer " + state.sessionState.token);
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("ad_name", ad_name);

    const fetchUrl =
        config.restUrl +
        "PDM/PrepareConfigurationXml?configuration_id=" +
        encodeURIComponent(configuration_id);

    try {
        console.log("Preparing PDM CAD BOM XML:", configuration_id);

        const response = await fetch(fetchUrl, {
            method: "GET",
            headers: headers
        });

        if (!response.ok) {
            console.log("PrepareConfigurationXml failed:", response.status, response.statusText);
            return false;
        }

        const result = await response.json();

        return result === true || result === "true";
    }
    catch (error) {
        console.log("PrepareConfigurationXml error:", configuration_id, error);
        return false;
    }
}

export async function DownloadConfigurationXml(instance, configuration_id, ad_name) {
    await GetToken(instance);

    const state = store.getState();
    const pdmUsername = sessionStorage.getItem("pdmUsername");
    const pdmPassword = sessionStorage.getItem("pdmPassword");

    const headers = new Headers();
    headers.append("Authorization", "Bearer " + state.sessionState.token);
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("ad_name", ad_name);

    const fetchUrl = config.restUrl + "PDM/DownloadConfigurationXml?configuration_id=" + encodeURIComponent(configuration_id);

    try {
        console.log("Downloading PDM CAD BOM XML:", configuration_id);
        console.log("Download URL:", fetchUrl);

        const res = await fetch(fetchUrl, {
            method: "GET",
            headers: headers
        });

        console.log("HTTP status:", res.status, res.statusText);

        if (!res.ok) {
            throw new Error("HTTP " + res.status + " - " + res.statusText);
        }

        const result = await res.json();

        console.log("Raw API result length:", result ? result.length : 0);

        if (!result || typeof result !== "string" || result.trim() === "") {
            throw new Error("Empty response from backend");
        }

        if (result.includes("Trace file was not downloaded")) {
            throw new Error("Backend returned error message instead of XML");
        }

        let xmlText = "";

        try {
            xmlText = atob(result);
        }
        catch (error) {
            console.log("Invalid base64 response:", result);
            throw new Error("Backend response is not valid base64");
        }

        console.log("Decoded XML length:", xmlText.length);
        console.log("Decoded XML preview:", xmlText.substring(0, 300));

        if (!xmlText || xmlText.trim() === "") {
            throw new Error("Decoded XML is empty");
        }

        if (!xmlText.trimStart().startsWith("<")) {
            throw new Error("Decoded response is not XML");
        }

        const blob = new Blob([xmlText], { type: "text/xml;charset=utf-8" });

        if (blob.size === 0) {
            throw new Error("Created XML blob is empty");
        }

        const a = document.createElement("a");
        document.body.appendChild(a);
        a.style.display = "none";

        const href = window.URL.createObjectURL(blob);
        a.href = href;
        a.download = configuration_id.replaceAll("/", "_") + "_PDMORDERXML.xml";
        a.click();

        window.URL.revokeObjectURL(href);
        document.body.removeChild(a);

        console.log("PDM CAD BOM XML download completed. Blob size:", blob.size);

        alert("XML file downloaded successfully");
    }
    catch (error) {
        console.log("PDM CAD BOM XML download failed:", error);
        alert("XML file downloading failed: " + error.message);
    }
    finally {
        sessionStorage.setItem("circularProgressXML", "false");
    }

    return null;
}

export async function fetchPDMDescription(instance, ad_name, material, revision) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("Authorization", bearer);
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("ad_name", ad_name);


    let output = null;
    await fetch(config.restUrl + "PDM/FetchPDMDescription/" + material + "/" + revision, {
        method: "GET",
        headers: headers
    }).then(res => res.json()).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function CancelDataValidation(instance, _validationID, _materials, _options, _ad_name, _batch_name, _last_run, _dvalert_status) {
    console.log("----Inside CancelDataValidation() function----");
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append("ad_name", _ad_name);
    headers.append("batch_name", _batch_name);
    headers.append("last_run", _last_run);
    headers.append("dvalert_status", _dvalert_status);
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);


    let output = null;
    await fetch(config.restUrl + "Validation/" + _validationID + "/Cancel", {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            // parameters
            "materials": _materials,
            "options": _options,
            "dvalertstatus": _dvalert_status
        })
    }
    ).then(res => res).then((result) => {
        //console.log("RESULT: ", result);
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function CancelBomCompare(instance, _compareID, _configurations, _compareto, _options, _ad_name, _compare_name, _last_run) {
    console.log("----Cancel BomCompare----");
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append("ad_name", _ad_name);
    headers.append("compare_name", _compare_name);
    headers.append("last_run", _last_run);

    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    console.log(_compareID);
    console.log(_configurations);
    console.log(_compareto);
    console.log(_options);
    console.log(_ad_name);
    console.log(_compare_name);
    console.log(_last_run);
    let output = null;
    await fetch(config.restUrl + "Compare/" + _compareID + "/Cancel", {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            // parameters
            "configurations": _configurations,
            "compareto": _compareto,
            "options": _options
        })
    }
    ).then(res => res).then((result) => {
        //console.log("RESULT: ", result);
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function DownloadAllResults(instance, batchName, configuration_id, orderName, result_type, ad_name, compare_name, downloadMode = "final") {
    await GetToken(instance);

    const state = store.getState();
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");

    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;

    headers.append("Authorization", bearer);
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("ad_name", ad_name);
    headers.append("configuration_id", configuration_id);
    headers.append("orderName", orderName);
    headers.append("batch_name", batchName);
    headers.append("result_type", result_type);
    headers.append("download_mode", downloadMode);

    if (typeof compare_name === "string" && compare_name.trim() !== "") {
        try {
            console.log("compareMap (raw):", compare_name);
            JSON.parse(compare_name);
            headers.append("compare_map", compare_name);
            console.log("compare_map header appended");
        } catch (e) {
            console.error("Invalid compareMap JSON, header not sent", e);
        }
    }

    let output = null;
    let fetchUrl = config.restUrl + "CWSConsole/DownloadAllResults";

    const callDownloadApi = async () => {
        return await fetch(fetchUrl, {
            method: "POST",
            headers: headers
        });
    };

    const readAndDownloadZip = async (response) => {
        const reader = response.body.getReader();
        const contentLength = response.headers.get("Content-Length");

        let receivedLength = 0;
        let chunks = [];
        let done = false;

        while (!done) {
            const result = await reader.read();
            done = result.done;

            if (done) break;

            const value = result.value;
            chunks.push(value);
            receivedLength += value.length;

            if (contentLength) {
                const total = Number(contentLength);
                const percent = Math.round((receivedLength / total) * 100);
                sessionStorage.setItem("downloadProgress", percent.toString());
            }
        }

        if (contentLength) {
            const expected = Number(contentLength);

            if (receivedLength < expected) {
                throw new Error("Download interrupted");
            }
        }

        const blob = new Blob(chunks);
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = batchName + ".zip";

        document.body.appendChild(a);
        a.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    };

    try {
        console.log("Starting download:", {
            batchName,
            configuration_id,
            ad_name
        });

        let response = await callDownloadApi();

        console.log("Response received:", response.status);
        console.log("Content-Length:", response.headers.get("content-length"));

        // If backend says zip is still preparing or gateway timed out,
        // do not fail immediately. Keep checking in background.
        if (response.status === 409 || response.status === 502 || response.status === 504) {
            sessionStorage.setItem("circularProgress", "false");

            alert(
                "Server is still preparing the zip file. You can continue working. " +
                "You will be notified when the download is ready."
            );

            const maxAttempts = 10;
            const retryDelayMs = 60000;

            for (let attempt = 1; attempt <= maxAttempts; attempt++) {
                console.log(`Checking if bulk zip is ready. Attempt ${attempt}/${maxAttempts}`);

                await delay(retryDelayMs);

                response = await callDownloadApi();

                console.log("Background retry response:", response.status);
                console.log("Background retry Content-Length:", response.headers.get("content-length"));

                if (response.ok) {
                    sessionStorage.setItem("circularProgress", "true");
                    sessionStorage.setItem("downloadProgress", "0");

                    await readAndDownloadZip(response);

                    sessionStorage.setItem("circularProgress", "false");

                    alert("Your batch download is ready and has started.");
                    return output;
                }

                if (response.status !== 409 && response.status !== 502 && response.status !== 504) {
                    const errorText = await response.text();
                    throw new Error("HTTP " + response.status + ": " + errorText);
                }
            }

            alert("The zip file is still not ready. Please try Download All again after some time.");
            return output;
        }

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error("HTTP " + response.status + ": " + errorText);
        }

        await readAndDownloadZip(response);

        sessionStorage.setItem("circularProgress", "false");

        setTimeout(() => {
            alert("File downloaded successfully");
        }, 3000);

        return output;
    }
    catch (error) {
        console.error("Download error:", error);

        sessionStorage.setItem("circularProgress", "false");

        let msg = "";

        if (error.message.includes("interrupted")) {
            msg = "File downloading failed (CWS web server is down. Please try again after some time.)";
        } else if (error.message.includes("504")) {
            msg = "Server is processing a large amount of data to build your zip, so your download may take a few more minutes.\nIMPORTANT:\nDO NOT REFRESH OR CLOSE THIS PAGE UNTIL THE DOWNLOAD OPTION APPEARS.";
        } else if (error.message.includes("500")) {
            msg = "File downloading failed (Server Error)";
        } else {
            msg = "File downloading failed (Network issue)";
        }

        setTimeout(() => {
            alert(msg);
        }, 3000);

        return output;
    }
}

export async function PrepareAndCheckResults(instance, _ad_name, request) {
    await GetToken(instance);

    const state = store.getState();

    const pdmUsername = sessionStorage.getItem("pdmUsername");
    const pdmPassword = sessionStorage.getItem("pdmPassword");

    const headers = new Headers();

    headers.append("Authorization", "Bearer " + state.sessionState.token);
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("ad_name", _ad_name);
    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/json");

    try {
        const response = await fetch(
            config.restUrl + "CWSConsole/results/prepare-and-existence",
            {
                method: "POST",
                headers: headers,
                body: JSON.stringify(request)
            }
        );

        if (!response.ok) {
            console.log("PrepareAndCheckResults failed", response.status, response.statusText);
            return {};
        }

        return await response.json();
    }
    catch (error) {
        console.log("PrepareAndCheckResults exception", error);
        return {};
    }
}

export async function CancellingBomCompare(instance, _compareID, _configurations, _compareto, _options) {
    console.log("----Cancelling BomCompare----");
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    console.log(_compareID);
    console.log(_configurations);
    console.log(_compareto);
    console.log(_options);

    let output = null;
    await fetch(config.restUrl + "Compare/" + _compareID + "/Cancelling", {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            // parameters
            "configurations": _configurations,
            "compareto": _compareto,
            "options": _options
        })
    }
    ).then(res => res).then((result) => {
        //console.log("RESULT: ", result);
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function CancellingCompareConsole(instance, _ad_name, _compare_name, _last_run) {
    console.log("----Acknowledging Cancelling BomCompare----");
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("Authorization", bearer);
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("ad_name", _ad_name);
    headers.append("compare_name", _compare_name);
    headers.append("last_run", _last_run);


    console.log(_ad_name);
    console.log(_compare_name);
    console.log(_last_run);
    let output = null;
    await fetch(config.restUrl + "CWSConsole/CancellingCompare", {
        method: 'GET',
        headers: headers
    }
    ).then(res => res).then((result) => {
        //console.log("RESULT: ", result);
        output = result;
    }).catch(error => {
        console.log(error);
    });
    console.log(output);
    return output;
}

export async function TrackingPDMConnection(instance) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("Authorization", bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    let output = null;
    await fetch(config.restUrl + "CWSConsole/TrackPDMConnection", {
        method: 'GET',
        headers: headers
    }
    ).then(res => res.json()).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function fetchDataFromPDM(instance, orders, items) {
    const requestBody = {
        orders: orders,
        items: items
    };
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("Authorization", bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    let output = null;
    try {

        const response = await fetch(config.restUrl + "Batch/fetchDatafromPDM", {
            method: "POST",
            headers: headers,
            body: JSON.stringify(requestBody)
        });
        if (response.ok) {
            const result = await response.json();
            output = result;
        } else {
            console.error('Failed to fetch data:', response.statusText);
            output = { error: response.statusText };
        }
    } catch (error) {
        console.error('Error fetching data:', error);
        output = { error: error.message };
    }

    return output;
}


export async function checkMaterialCharacteristics(instance, ad_name, material, revision) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("Authorization", bearer);
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("ad_name", ad_name);

    let output = null;
    await fetch(config.restUrl + "PDM/CheckFetchPDMDescription/" + material + "/" + revision, {
        method: "GET",
        headers: headers
    }).then(res => res.json()).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function checkCADPackage(instance, _material, _materialRevision) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("Authorization", bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');

    headers.append("material", _material);
    headers.append("materialRevision", _materialRevision);
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    let output = null;
    console.log(_material);
    console.log(_materialRevision);
    await fetch(config.restUrl + "CWSConsole/CheckCADPackage", {
        method: 'GET',
        headers: headers
    }
    ).then(res => res.json()).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function GetAllADUsers(instance) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("Authorization", bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');

    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    let output = null;
    await fetch(config.restUrl + "CWSConsole/all-users", {
        method: 'GET',
        headers: headers
    }
    ).then(res => res.json()).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function getAllMaterialNames(instance) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("Authorization", bearer);

    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    let output = null;
    await fetch(config.restUrl + "Batch/getAllMaterialOrderCount",
        {
            method: "GET",
            headers: headers
        }
    ).then(res => {
        return res.json();
    }
    ).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function getAllValidationCount(instance) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("Authorization", bearer);

    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    let output = null;
    await fetch(config.restUrl + "Validation/getAllValidationCount",
        {
            method: "GET",
            headers: headers
        }
    ).then(res => {
        return res.json();
    }
    ).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function getAllCompareCount(instance, compareType) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("Authorization", bearer);

    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("compareType", compareType);
    let output = null;
    await fetch(config.restUrl + "Compare/getAllCompareCount",
        {
            method: "GET",
            headers: headers
        }
    ).then(res => {
        return res.json();
    }
    ).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function fetchAllMaterialNames(instance) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("Authorization", bearer);

    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    let output = null;
    await fetch(config.restUrl + "Batch/fetchAllMaterialNames",
        {
            method: "GET",
            headers: headers
        }
    ).then(res => {
        return res.json();
    }
    ).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function checkUserAdminRole(instance) {
    console.log("--------checkUserAdminRole--------");
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("Authorization", bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');

    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    let output = null;
    await fetch(config.restUrl + "CWSConsole/checkADUser", {
        method: 'GET',
        headers: headers
    }
    ).then(res => res.json()).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function GetAllUserMails(instance) {
    console.log("--------getUserMails--------");
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("Authorization", bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');

    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    let output = null;
    await fetch(config.restUrl + "CWSConsole/all-users-email", {
        method: 'GET',
        headers: headers
    }
    ).then(res => res.json()).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function markStatusFlag() {
    const resultFlag = sessionStorage.getItem("trackPDMConnectionStatus");
    document.getElementById("SuccessStatus").style.display="none";
    document.getElementById("FailedStatus").style.display="block";
    if(resultFlag=="Success")
    {
      document.getElementById("SuccessStatus").style.display="block";
      document.getElementById("FailedStatus").style.display="none";
    }
}

export async function checkIfMCZipEmpty(instance, config_id, ad_name, last_run) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    headers.append("Authorization", bearer);
    headers.append("ad_name", ad_name);
    headers.append("last_run", last_run);
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);

    let fetchUrl = config.restUrl + "Compare/getMCResultStatus/" + config_id;
    try {
        const res = await fetch(fetchUrl, { method: "GET", headers });
        const data = await res.json();
        if (!data.success) {
            console.warn(`MC zip check failed for: ${config_id} - ${data.message}`);
            return { empty: true, message: data.message };
        } else {
            console.info(`MC zip exists for: ${config_id}`);
            return { empty: false, message: data.message };
        }
    } catch (error) {
        console.error("Error checking MC zip:", error);
        return { empty: true, message: error.message };
    }
}

export async function getInactiveUsersDataFromTable(instance, ad_name) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("Authorization", bearer);

    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("ad_name", ad_name);
    let output = null;
    await fetch(config.restUrl + "Batch/getInactiveUsersDataFromTable",
        {
            method: "GET",
            headers: headers
        }
    ).then(res => {
        return res.json();
    }
    ).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}

export async function archiveInactiveUsersData(instance, ad_name, selectedEmailIDs) {
    await GetToken(instance);
    const state = store.getState();
    let headers = new Headers();
    let bearer = "Bearer " + state.sessionState.token;
    let pdmUsername = sessionStorage.getItem("pdmUsername");
    let pdmPassword = sessionStorage.getItem("pdmPassword");
    headers.append("Authorization", bearer);

    headers.append("username", pdmUsername);
    headers.append("password", pdmPassword);
    headers.append("ad_name", ad_name);
    headers.append("selectedEmailIDs", selectedEmailIDs);
    let output = null;
    await fetch(config.restUrl + "Batch/archiveInactiveUsersData",
        {
            method: "DELETE",
            headers: headers
        }
    ).then(res => {
        return res.json();
    }
    ).then((result) => {
        output = result;
    }).catch(error => {
        console.log(error);
    });
    return output;
}
